interface BillboardUrlParams {
  areaId: number | null;
  areaType: string | null;
  date: string | null;
  format: string[];
  lang: string[];
  hours: {
    min: number;
    max: number;
  };
  cinema: number[];
  movie: number[];
}
export const extractUrlParams = (path: string, params: { [key: string]: any }): BillboardUrlParams => ({
  areaId: params && extractUrlAreaId(params),
  areaType: params && 'zona' === params.areaType ? 'area' : 'state',
  date: extractUrlDate(path),
  format: extractUrlFormats(path),
  lang: extractUrlLanguages(path),
  hours: extractUrlHours(path),
  cinema: extractUrlCinema(path),
  movie: extractUrlMovie(path),
});

const extractUrlDate = (path: string): string | null => {
  const match = path.match(/\bfecha-([0-9]{4})([0-9]{2})([0-9]{2})\b/);

  if (match) {
    return match[1] + '-' + match[2] + '-' + match[3];
  } else {
    return null;
  }
};

const extractUrlFormats = (path: string): string[] => {
  const match = path.match(/\bformato-([a-z0-9,_]+)\b/);

  if (!match) {
    return [];
  } else {
    return match[1].split(',');
  }
};

const extractUrlLanguages = (path: string): string[] => {
  const match = path.match(/\bidioma-([a-z,]+)\b/);

  if (!match) {
    return [];
  } else {
    return match[1].split(',').map(lang => 'lang_' + lang);
  }
};

export const hoursRange = {min: 9, max: 24};
const extractUrlHours = (path: string): {min: number, max: number} => {
  const match = path.match(/\bhoras-(\d+)a(\d+)\b/);

  if (!match) {
    return hoursRange;
  } else {
    return {min: parseInt(match[1], 10), max: parseInt(match[2], 10)};
  }
};

const extractUrlCinema = (path: string): number[] => extractUrlIds(path, 'cine');

const extractUrlMovie = (path: string): number[] => extractUrlIds(path, 'pelicula');

const extractUrlIds = (path: string, base: string): number[] => {
  const re = new RegExp('\\b' + base + '-([\\d,]+)\\b');
  const match = path.match(re);

  if (!match) {
    return [];
  } else {
    return match[1].split(',').map(id => parseInt(id, 10));
  }
};

const extractUrlAreaId = (params: { [key: string]: any }): number => parseInt(params.area, 10);

export const filterDatesBeforeToday = (dates: string[]): string[] => {
  const today = new Date();
  const todayYmd = dateObjectToYmdString(today);
  
  return dates.filter(date => {
    return parseInt(date.split('-').join(''), 10) >= todayYmd;
  });
};

const dateObjectToYmdString = (date: Date): number => date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate();